module.exports = __webpack_public_path__ + "/images/testimonial-estefania.bc52bcc.jpg";